import { render, staticRenderFns } from "./CarouselIndicators.vue?vue&type=template&id=49d89129&scoped=true"
import script from "./CarouselIndicators.vue?vue&type=script&lang=js"
export * from "./CarouselIndicators.vue?vue&type=script&lang=js"
import style0 from "./CarouselIndicators.vue?vue&type=style&index=0&id=49d89129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d89129",
  null
  
)

export default component.exports